import { useQuery } from '@tanstack/react-query';
import { getLocationReferralSummary, queryKeys } from '@vgrubs/components';

/**
 * Who referred this location, and how many restaurants it referred itself.
 *
 * Its own request: the page is built from `GET /v1/locations/:id`, and only
 * the v2 answer carries these two fields. Silent on failure - a referral line
 * that cannot load is no reason to bother anyone on this page.
 */
export const useLocationReferralSummary = (locationId: string) => {
  const query = useQuery({
    queryKey: queryKeys.restaurantReferrals.locationSummary(locationId),
    queryFn: async () => {
      const { data } = await getLocationReferralSummary(locationId);
      return {
        referredBy: data.data.referredBy ?? null,
        restaurantReferralsCount: data.data.restaurantReferralsCount ?? 0,
      };
    },
  });

  return query.data ?? null;
};
